// extracted by mini-css-extract-plugin
export default {"div":"Coupons_div__ZAag4"};